/* @flow */

export enum LoadableStatus {
  NotInitialized,
  Loaded,
  Error,
}
